
import { SWRConfiguration, SWRResponse } from 'swr';

import { Authenticate, AuthenticateResponse } from '@/apis/dtos';
import useGet from '../apis/useGet';

const getRequest = () => new Authenticate();
const getData = (response?: SWRResponse<AuthenticateResponse, AuthenticateResponse>) => response?.data;
const getError = (response?: SWRResponse<AuthenticateResponse, AuthenticateResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useAuthenticatedUser = (configuration: SWRConfiguration) => {
    return useGet(getRequest, { getData, getError }, configuration);
}